import styled from 'styled-components'
import { textMuted } from '@/theme/colors'
import { fontSizes } from '@/theme/typography'
import { Button } from '@components/Button'




export const AddIdeaButton = styled(Button)``

/** Shown when the filters exclude every idea — distinct from the zero-ideas state. */
export const NoMatches = styled.p`
	padding: 48px 16px;
	text-align: center;
	color: ${textMuted};
	font-size: ${fontSizes.base};
	margin: 0;
`


